import { Alert } from "@jhool-io/fe-components";
import { Outlet } from "react-router-dom";
import { ErrorBoundary } from "react-error-boundary";
import * as Sentry from "@sentry/react";
import SideNav from "../../components/SideNav/SideNav";
import { useAppDispatch, useAppSelector } from "../../hooks/useRedux";
import { cn } from "../../utils/helpers";
import ContentFallback from "../../components/ErrorBoundaryFallback/ContentFallback/ContentFallback";
import { hideBanner } from "../../redux/features/banner/bannerSlice";

export default function AppContainer() {
    const { isOpen } = useAppSelector((state) => state.nav);

    const { message, isVisible } = useAppSelector((state) => state.banner);

    const dispatch = useAppDispatch();

    return (
        <div className="bg-[#fbfbfb]">
            <div className="flex">
                <SideNav />
                <ErrorBoundary
                    fallback={<ContentFallback />}
                    onError={(err) => {
                        Sentry.captureException(err);
                    }}
                >
                    <div
                        className={cn(
                            "flex-1 min-h-screen transition-[margin-left] duration-[250ms] ease-out overflow-auto",
                            isOpen
                                ? "ml-0 md:ml-[var(--sidebar-width)]"
                                : "ml-0"
                        )}
                    >
                        <main id="main" className="pb-48">
                            {isVisible ? (
                                <Alert
                                    type="warning"
                                    description={message}
                                    showCloseButton
                                    onCloseButtonClick={() =>
                                        dispatch(hideBanner())
                                    }
                                />
                            ) : null}
                            <Outlet />
                        </main>
                    </div>
                </ErrorBoundary>
            </div>
        </div>
    );
}
